/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05cbb9f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex-line"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "data"
};
const _hoisted_4 = {
  class: "name"
};
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/modules/app';
import { apiGsOverview, apiGSIncomeCurrentList } from '@/api/gsManage';
import GsEarning from './gsEarning.vue';
import RoleDetail from './roleDetail.vue';
import chargeDetail from './chargeDetail.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      gameInfo
    } = storeToRefs(useAppStore());
    const currencyList = ref();
    const overviewLoading = ref(false);
    const activeKey = ref('totalData');
    const currentCurrency = ref('USD');
    const panes = ref([{
      title: '汇总数据',
      key: 'totalData'
    }]);
    const totalList = ref([{
      title: '推广订单总额',
      key: 'total_income'
    }, {
      title: '本月推广订单总额',
      key: 'month_income'
    }, {
      title: '当日推广订单总额',
      key: 'today_income'
    }, {
      title: '现存GS总数',
      key: 'gs_count'
    }, {
      title: 'GS绑定角色总数',
      key: 'role_count'
    }]);
    const overviewData = reactive({
      gs_count: undefined,
      month_income: undefined,
      role_count: undefined,
      today_income: undefined,
      total_income: undefined
    });
    const getOverviewData = async () => {
      const params = {
        is_over_view: 1,
        game_id: gameInfo.value.Id,
        currency: currentCurrency.value
      };
      overviewLoading.value = true;
      const res = await apiGsOverview(params);
      overviewLoading.value = false;
      if (res.code === 0) {
        overviewData.gs_count = res.data.gs_count;
        overviewData.month_income = res.data.month_income && res.data.month_income.toFixed(2);
        overviewData.role_count = res.data.role_count;
        overviewData.today_income = res.data.today_income && res.data.today_income.toFixed(2);
        overviewData.total_income = res.data.total_income && res.data.total_income.toFixed(2);
      }
    };
    const getCurrencyList = async () => {
      const res = await apiGSIncomeCurrentList({});
      if (res.code === 0) {
        currencyList.value = res.data;
      }
    };
    onMounted(() => {
      getCurrencyList();
    });
    watch(() => gameInfo.value.Id, val => {
      if (val) getOverviewData();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_u_card, {
        modelValue: _unref(activeKey),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(activeKey) ? activeKey.value = $event : null),
        panes: _unref(panes),
        class: "margin-pane"
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _unref(currentCurrency),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentCurrency) ? currentCurrency.value = $event : null),
          style: {
            "width": "160px"
          },
          onChange: getOverviewData
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyList), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.currency
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "totalData"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(totalList), item => {
            return _openBlock(), _createElementBlock("div", {
              class: "flex-item",
              key: item.key
            }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_unref(overviewData)[item.key] || _unref(overviewData)[item.key] === 0 ? _unref(overviewData)[item.key] : '-'), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1)])]);
          }), 128))])), [[_directive_loading, _unref(overviewLoading)]])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "panes"]), _createVNode(GsEarning, {
        "game-id": _unref(gameInfo).Id,
        "currency-list": _unref(currencyList)
      }, null, 8, ["game-id", "currency-list"]), _createVNode(RoleDetail, {
        "game-id": _unref(gameInfo).Id,
        "currency-list": _unref(currencyList)
      }, null, 8, ["game-id", "currency-list"]), _createVNode(chargeDetail, {
        "game-id": _unref(gameInfo).Id,
        "currency-list": _unref(currencyList)
      }, null, 8, ["game-id", "currency-list"])]);
    };
  }
});